export default __webpack_public_path__ + "static/media/pouf6.c54d0608.JPG";